module.exports = __webpack_public_path__ + "static/8-13e9171da869b9f74432283f39d5be5d.jpg";